import React, { useEffect, useState } from 'react';
import { Chart } from 'react-google-charts'; // Import the Chart component
import './../../assets/css/riskmatrix.css';
import Loader from '../commonForm/Loader';
import axios from 'axios';
import useUserStore from '../../store/UserStore';
import { BASE_URL } from '../../constant/const.js';
import { useNavigate } from 'react-router-dom';
import { t } from '../Language/Translator.js';

const AdminPieChart = () => {
    const [data, setData] = useState([]); // State for the pie chart data
    const [loading, setLoading] = useState(true); // State for loading status
    const user_data = useUserStore((state) => state.user);
    const token = user_data;
    const SEVERITIES = ["Critical", "High", "Medium", "Low", "Info"];
    const navigate=useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const config = {
                    headers: {
                        "Content-type": "application/json",
                        "Authorization": token,
                    },
                };
                const response = await axios.get(`${BASE_URL}dashboard`, config);
                

                const tabdata = [
                    ['Risk Level', 'Count'], // Header for the Google Chart
                    ['Critical', response.data.criticalviolation],
                    ['High', response.data.highrisk],
                    ['Medium', response.data.mediumrisk],
                    ['Low', response.data.lowrisk],
                    ['Info', response.data.inforisk],
                ];

            
                setData(tabdata); // Set the chart data
                setLoading(false); // Update loading status
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false); // Update loading status on error
            }
        };
        fetchData(); // Fetch data when the component mounts or token changes
    }, [token]);

    

    if (loading) {
        return <Loader />; // Show loader while data is being fetched
    }

    const pieChartOptions = {
        is3D: true,
        pieSliceText: "percentage",
        pieSliceTextStyle: { fontSize: 18 },
        focusTarget: "category", // Highlights the whole category on hover
        enableInteractivity: true,
        slices: {
            0: { color: "#D32F2F" }, // Dark Red
            1: { color: "#F57C00" }, // Orange
            2: { color: "#FFC107" }, // Yellow
            3: { color: "#388E3C" }, // Green
            4: { color: "#1976D2" }  // Blue
        },
        chartArea: { width: '80%', height: '80%' },
        backgroundColor: "transparent",
        legend: "none",
        tooltip: { textStyle: { fontSize: 16, bold: false } },

    };

    const handleChartClick = ({ chartWrapper }) => {
        const chart = chartWrapper.getChart();
        const selection = chart.getSelection();
        

        if (selection.length > 0) {
            const sliceIndex = selection[0].row
            if (sliceIndex !== null || sliceIndex !== undefined) {
                const severity = SEVERITIES[sliceIndex];
                navigate(`/tickets?severity=${severity}`);
            }
        }
    };



    return (
        <div className='piechart_graph'>
            <div className='mt-3 ml-3'>
            <h5 className="text-white text-center my-2">{t("admindashboardgraphs.piecharttitle")}</h5>
            </div>
            <Chart
                chartType="PieChart"
                data={data} // Use the processed data
                loader={<Loader />}
                options={pieChartOptions}
                width="100%"
                height="350px"
                chartEvents={[
                    {
                        eventName: "select", callback:
                            handleChartClick
                    }]}

            />
            <div className="flex justify-center xl:gap-3 gap-2 mt-12 sm:flex-nowrap flex-wrap mx-auto">
                {data.slice(1).map((severity, index) => ( // Skip header row
                    <div key={index} className="flex items-center space-x-2">
                        <span
                            className="w-4 h-4 rounded-full"
                            style={{ backgroundColor: pieChartOptions.slices[index].color }} // Use color from pie chart options
                        ></span>
                        <span className="text-sm font-medium capitalize text-white">{severity[0]}</span> {/* Show severity label */}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminPieChart;
